import React, { forwardRef } from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Input from '../Input';
import { ConfidenceLabelProps } from '../ConfidenceLabel';
import './DateInput.css';

export type DateInputProps = ReactDatePickerProps & ConfidenceLabelProps;

const defaultDateFormat = 'dd.MM.yy';

const DateInput = forwardRef<DatePicker, DateInputProps>(
  (
    {
      dateFormat = defaultDateFormat,
      confidenceAutomated,
      confidenceLevel,
      confidenceValue,
      ignored,
      ...rest
    }: DateInputProps,
    ref
  ): JSX.Element => {
    const customInput = (
      <Input
        confidenceAutomated={confidenceAutomated}
        confidenceLevel={confidenceLevel}
        confidenceValue={confidenceValue}
        ignored={ignored}
      />
    );
    return <DatePicker dateFormat={dateFormat} ref={ref} {...rest} customInput={customInput} />;
  }
);

DateInput.displayName = 'DateInput';

export default DateInput;
